module.exports = __webpack_public_path__ + "img/horizontal_7_1_pp1_9016.6cc65b88.png";